import "./index.css";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { BsCheck, BsCheck2Circle, BsCheckLg } from "react-icons/bs";

const Pricing = () => {
  const pricingPlans = [
    {
      title: "Diamond",
      mrp: "5999",
      price: "3999",
      period: "per month, Billed Monthly.",
      features: ["Lead Management", "Basic Reports", "Email Support"],
      buttonText: "Get Started",
      buttonVariant: "outline-primary",
    },
    {
      title: "Platinum",
      mrp: "5999",
      price: "3599",
      period: "per month, Billed Yearly.",
      features: ["Lead & Booking Management", "Advanced Reports", "Priority Support"],
      buttonText: "Get Started",
      buttonVariant: "primary",
    },
    {
      title: "Enterprise",
      mrp: "5999",
      price: "2599",
      period: "per month, Billed every 3 Year.",
      features: ["Full CRM Suite", "Custom Integrations", "Dedicated Support"],
      buttonText: "Get Started",
      buttonVariant: "outline-dark",
    },
  ];

  return (
    <div className="pricing-wrapper bg-light" id="pricing" >
      <Container>
        <h2 className="fw-bold text-center">Choose Your Plan</h2>
        <p className="text-center text-muted mb-5">
          Flexible pricing plans tailored to your real estate business needs.
        </p>
        <Row className="g-4">
          {pricingPlans.map((plan, index) => (
            <Col md={4} key={index}>
              <Card className="pricing-card text-center py-4 shadow-sm">
                <Card.Body>
                  <h3 className="fw-bold">{plan.title}</h3>
                  <div className="d-flex align-items-center justify-content-center">
                    <h1 className="text-muted">
                      <span className="h3 me-1">₹</span>
                      <span className="text-decoration-line-through">{plan.mrp}</span>
                    </h1>
                    <h1 className="fw-bold">
                      <span className="h3 me-1">₹</span>
                      {plan.price}
                    </h1>
                  </div>
                  <p className="text-muted">{plan.period}</p>
                  <ul className="list-unstyled">
                    {plan.features.map((feature, i) => (
                      <li key={i} className="py-1 d-flex align-items-center justify-content-center">
                        <div>
                          <BsCheckLg size={18} />
                        </div>
                        <div className="ms-1">
                          {feature}
                        </div>
                      </li>
                    ))}
                  </ul>
                  <Button variant={plan.buttonVariant} className="mt-3 w-100">
                    {plan.buttonText}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Pricing;